var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "autocomplete" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.inputValue,
          expression: "inputValue"
        }
      ],
      class: [
        _vm.classValue,
        {
          "loading-circle": _vm.inputValue.length > 0,
          "hide-loading-circle":
            _vm.resultItems.length > 0 ||
            (_vm.resultItems.length == 0 && !_vm.autoCompleteProgress)
        }
      ],
      attrs: {
        type: "text",
        placeholder: _vm.placeHolderText,
        maxlength: _vm.maxlength
      },
      domProps: { value: _vm.inputValue },
      on: {
        input: [
          function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.inputValue = $event.target.value
          },
          function($event) {
            !_vm.autoCompleteProgress ? _vm.onKeyUp(_vm.inputValue) : "",
              (_vm.arrowCounter = 0)
          }
        ],
        keyup: [
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "down", 40, $event.key, [
                "Down",
                "ArrowDown"
              ])
            ) {
              return null
            }
            return _vm.down($event)
          },
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
            ) {
              return null
            }
            return _vm.up($event)
          },
          function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.onEnter($event)
          }
        ]
      }
    }),
    _vm._v(" "),
    _vm.resultItems.length > 0
      ? _c(
          "ul",
          {
            staticClass: "autocomplete-results",
            style: _vm.styleValue,
            attrs: { id: "autocomplete-results" }
          },
          _vm._l(_vm.resultItems, function(item, i) {
            return _c(
              "li",
              {
                key: i,
                staticClass: "autocomplete-result",
                class: { "is-active": i === _vm.arrowCounter },
                on: {
                  click: function($event) {
                    return _vm.onSelected(item.itemList)
                  }
                }
              },
              [_vm._v("\n\t\t\t\t\t" + _vm._s(item.itemText) + "\n\t\t\t\t")]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20d6b766", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20d6b766","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/autocomplete_modal.vue
// module id = null
// module chunks = 